<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <!--      <div class="sec-wight-bg py-5 ">
              <div class="container sec-garay-bg border-radius">
                <div class="row ">
                  <h5 class="text-blue col py-0">
                    اخبار و مقالات
                  </h5>
                  <router-link to="BlogCategories" >

                    <p class="text-left col more py-0"><a>مشاهده بیشتر</a></p>
                  </router-link>
                </div>
              </div>
              <div v-if="latestBlogPosts !== undefined && latestBlogPosts.length >0" class="container p-0" dir="ltr">
                  <div class="col-12 px-0" v-for="item in latestBlogPosts" :key="item.id">
                    <router-link :to="{path: 'BlogPostsdetails',query:{BlogPostDetail:item.id}}">
                      <v-img :src="$replaceHttps(item.image)" class="mx-auto border-radius-productName " height="300px"></v-img>
                      <div class="sec-garay-bg border-radius-product-btn ">
                        <div class="pt-10 px-5 ">{{ item.title }}</div>
                        <div class="pt-10 px-5 gray-taxt" v-html="item.description"></div>
                        <v-divider></v-divider>
                        <div class="row">
                          <div class="col text-center gray-taxt"><i class="fas fa-eye"></i>{{ item.views }}</div>
                          <div class="col text-center gray-taxt">{{ item.createDate }}<i class="fas fa-calendar-alt"></i></div>
                        </div>
                      </div>
                    </router-link>
                  </div>
              </div>
            </div>-->
      <div v-if="BlogPosts !== undefined && BlogPosts.length >0" class="container " dir="ltr">
        <div class="row">
          <div class="col-12 col-md-4 " v-for="item in BlogPosts" :key="item.id">
            <router-link :to="{path: 'BlogPostsdetails',query:{BlogPostDetail:item.id}}">
              <v-img :src="$replaceHttps(item.image)" class="mx-auto border-radius-productName " height="200px"></v-img>
            </router-link>
            <div class="sec-garay-bg border-radius-product-btn ">
              <div class="pt-10 px-5 ">{{ item.title }}</div>
              <div class="pt-10 px-5 gray-taxt" v-html="item.description"></div>
              <v-divider></v-divider>
              <div class="row">
                <div class="col text-center gray-taxt"><i class="fas fa-eye"></i>{{ item.views }}</div>
                <div class="col text-center gray-taxt">{{ item.createDate }}<i class="fas fa-calendar-alt"></i></div>
              </div>
            </div>
            <div class="row">
              <!--                  <div class="col text-center gray-taxt"><i class="fas fa-eye"></i>{{ BlogCategories.views }}</div>
                                <div class="col text-center gray-taxt">{{ BlogCategories.createDate }}<i class="fas fa-calendar-alt"></i></div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>
<script>

import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";

export default {
  name: "BlogPosts",
  components: {FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-اخبار و مقالات'
  },
  data: () => ({
    isPageLoaded: false,
    BlogPosts: {},
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "Home/BlogPosts?CategoryId=" + this.$route.query.BlogPosts, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            this.BlogPosts = json
            this.showLoaderDialog = false;
            this.isPageLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>